import React from 'react';
import { createRoot } from 'react-dom/client';

import './config/i18n';
import 'react-toastify/dist/ReactToastify.css';
import './scss/application.scss';
import './scss/global.css';
import './scss/tailwind.css';
import App from './app';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
